import { render, staticRenderFns } from "./chat-in-progress.vue?vue&type=template&id=c8925f68&scoped=true&"
import script from "./chat-in-progress.vue?vue&type=script&lang=js&"
export * from "./chat-in-progress.vue?vue&type=script&lang=js&"
import style0 from "./chat-in-progress.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./chat-in-progress.vue?vue&type=style&index=1&id=c8925f68&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c8925f68",
  null
  
)

export default component.exports